import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.51 3.607v16h13V8.27l-4.664-4.664H5.51zM4.023 2.119a1.75 1.75 0 011.237-.512h9a1 1 0 01.707.293l5.25 5.25a1 1 0 01.293.707v12a1.75 1.75 0 01-1.75 1.75H5.26a1.75 1.75 0 01-1.75-1.75v-16.5c0-.464.185-.91.513-1.238z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.26 1.607a1 1 0 011 1v4.25h4.25a1 1 0 110 2h-5.25a1 1 0 01-1-1v-5.25a1 1 0 011-1zM16.207 11.293a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414 0l-2-2a1 1 0 111.414-1.414L11 15.086l3.793-3.793a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
